import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {
  accessDenied: boolean = false;

  constructor(
    private translateService: TranslateService,
    public commonService: CommonService,
    private router: Router
    ) { }

  ngOnInit(): void {
    if(this.checkUrlForAccessDenied()){
      this.accessDenied = true;
    }
    this.translateService.setDefaultLang(localStorage.getItem('userTempLang'));
  }

  public checkUrlForAccessDenied(): boolean {
    const currentUrl = this.router.url;
    if (currentUrl.endsWith('access-denied')) {
      return true;
    } else {
      return false;
    }
  }

}
